module.exports = __webpack_public_path__ + "static/media/github-background-2.91054c0f.svg";